import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_facilitylocationmaint } from "../shared/data.service";

import { wsFacilityLocationAddParm } from "../shared/wsFacilityLocationAddParm";
import { wsSchoolFacilityListInfo } from "../shared/wsSchoolFacilityListInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./locationadd.component.html",
	styleUrls: ["./locationadd.component.css"],
	providers: [ConfirmationService],
})
export class LocationAddComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_facilitylocationmaint,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public SchoolID: number;

	public lstSchoolFacility: wsSchoolFacilityListInfo[] = [];
	public SelectedSchoolFacility: wsSchoolFacilityListInfo;

	public FacilityLocationCD: string = "";
	public FacilityLocationName: string = "";

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.isBusy = true;
		this.dataService.SchoolFacilitySelectList(this.SchoolID).subscribe((data) => this.SchoolFacilitySelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SchoolFacilitySelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	SchoolFacilitySelectList_Complete(data: any) {
		this.lstSchoolFacility = data;

		//
		//	Default select
		//
		this.SelectedSchoolFacility = this.lstSchoolFacility[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolFacilityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAdd
	//
	//-----------------------------------------------------------------------------------------------------
	onAdd() {
		this.ErrorMessage = "";

		let parms: wsFacilityLocationAddParm = {
			FacilityLocationCD: this.FacilityLocationCD,
			FacilityLocationName: this.FacilityLocationName,
			FacilityID: this.SelectedSchoolFacility.FacilityID,
		};

		this.isBusy = true;
		this.dataService.FacilityLocationAdd(parms).subscribe((data) => this.FacilityLocationAdd_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationAdd_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
